export const INTRO_SCREEN = 0;
export const QUIZ_SCREEN = 1;
export const RESULTS_SCREEN = 2;
